import React from 'react';

import { useNavigationContext } from './context';
import { HomeScreen, JourneyScreen, KeyToSuccessScreen } from './screen';

export const SwitchNavigator = React.memo(() => {
  const { current } = useNavigationContext();

  switch (current) {
    case 'home':
      return <HomeScreen />;
    case 'journey':
      return <JourneyScreen />;
    case 'key_to_success':
      return <KeyToSuccessScreen />;
    default:
      return null;
  }
});
